import React from 'react';
import { ReactComponent as GoBackButton } from '../../../assets/svg/GoBackButton.svg';
import { ReactComponent as AiBuddy } from '../../../assets/svg/AiBuddy.svg';
import { ReactComponent as SolutionArrowRight } from '../../../assets/svg/SolutionArrowRight.svg';
import { ReactComponent as Explore } from '../../../assets/svg/Explore.svg';
import MDEditor from '@uiw/react-md-editor';
import { fileSystemUrl } from '../../../server/connections';
import { setSolutionCategoryIcon } from '../../../constants/constants';

function TopicScreen({ currentTopic, openSolution, setCurrentMode }: { currentTopic: any; openSolution: any; setCurrentMode: any }) {
	return (
		<div className='w-full px-5 py-[10px] h-[calc(100%-54px)] overflow-auto scrollbar-display-none'>
			<div className='flex flex-row justify-center'>
				<p className='font-bold text-[#02393E] text-[20px] leading-[26px] text-center'>{currentTopic?.title}</p>
			</div>
			<div className='relative mt-7'>
				{!!currentTopic?.image && (
					<div className='w-full mt-[35px]'>
						<img style={{ objectFit: 'contain', width: '100%' }} src={fileSystemUrl + '/' + currentTopic.image?.url} alt='' />
					</div>
				)}
				<div className='absolute top-1 right-1 h-[50px] min-w-[108px] bg-primaryViolet rounded-full flex flex-row items-center'>
					<div className='w-[50px] h-[50px] border-[3px] border-primaryViolet bg-white rounded-full flex items-center justify-center'>
						{setSolutionCategoryIcon(currentTopic?.category?.name)}
					</div>
					<p className='font-semibold text-white text-[16px] leading-[20px] pr-1'>{currentTopic?.category?.name}</p>
				</div>
			</div>
			<div className='pl-[6px] pr-[30px]'>
				<div
					className='py-[15px] px-[20px] w-full min-h-[56px] bg-[#ECEBF8] rounded-[10px] rotate-[2.51deg] relative flex items-center justify-center z-[3]'
					style={{ boxShadow: '0px 11px 16px 0px #20D4BF33' }}
				>
					<MDEditor.Markdown style={{ backgroundColor: 'transparent', color: '#7A7996', fontSize: 20, fontFamily: 'Quicksand' }} className='preview-list' source={currentTopic.quotes[0]} />
					<div className='absolute -top-2 left-[80%] w-[20px] h-[20px] bg-[#ECEBF8] rounded-[4px] rotate-45 '></div>
				</div>
			</div>
			<div className='pl-[14px] pr-[22px]'>
				<div
					className='mt-[8px] py-[15px] px-[20px] w-full min-h-[56px] bg-[#C3F0CC] rounded-[10px] -rotate-[3.48deg] relative flex items-center justify-center z-[2]'
					style={{ boxShadow: '0px 11px 16px 0px #20D4BF33' }}
				>
					<MDEditor.Markdown style={{ backgroundColor: 'transparent', color: '#7A7996', fontSize: 20, fontFamily: 'Quicksand' }} className='preview-list' source={currentTopic.quotes[1]} />
					<div className='absolute -top-2 left-[10%] w-[20px] h-[20px] bg-[#C3F0CC] rounded-[4px] rotate-45 '></div>
				</div>
			</div>
			<div className='pl-[18px] pr-[19px]'>
				<div
					className='mt-[8px] py-[15px] px-[20px] w-full min-h-[56px] bg-[#AAEDE9] rounded-[10px] rotate-[3.62deg] relative flex items-center justify-center z-[1]'
					style={{ boxShadow: '0px 11px 16px 0px #20D4BF33' }}
				>
					<MDEditor.Markdown style={{ backgroundColor: 'transparent', color: '#7A7996', fontSize: 20, fontFamily: 'Quicksand' }} className='preview-list' source={currentTopic.quotes[2]} />
					<div className='absolute -top-2 left-[70%] w-[20px] h-[20px] bg-[#AAEDE9] rounded-[4px] rotate-45 '></div>
				</div>
			</div>
			<div className='mt-[30px]'>
				{currentTopic?.solutions?.map((solution: any, index: number) => {
					return (
						<div
							className='p-5 rounded-[10px] bg-white mb-[10px] flex flex-row items-end gap-5 cursor-pointer'
							style={{ boxShadow: '0px 11px 16px 0px #20D4BF33 ' }}
							key={solution?.id}
							onClick={() => openSolution(solution?.id)}
						>
							<div className='flex-1 flex flex-col gap-[10px]'>
								<p className='font-bold text-[#02393E] text-[16px] leading-[20px] '>Solution {index + 1}.</p>
								<p className='font-bold text-[#BF9ED9] text-[20px] leading-[26px] '>{solution?.title}</p>
							</div>
							<div className=''>
								<SolutionArrowRight />
							</div>
						</div>
					);
				})}
			</div>
			{/* <div className='mt-[25px]'>
				{currentTopic?.paragraphs?.map((paragraph: any, index: number) => {
					return paragraph.type === 'LIST' ? (
						<div className='mb-5 border border-[#F2F6FF] p-5 rounded-[10px]' key={index}>
							<div className={`flex flex-row gap-[10px] `}>
								<MDEditor.Markdown
									style={{ backgroundColor: 'transparent', color: '#413F5E', fontSize: 16, fontFamily: 'Quicksand' }}
									className='preview-list'
									source={paragraph.text}
								/>
							</div>
						</div>
					) : (
						<MDEditor.Markdown
							style={{ marginBottom: 20, backgroundColor: 'transparent', color: '#02393E', fontSize: 16, fontFamily: 'Quicksand' }}
							className='preview-list'
							source={paragraph.text}
							key={index}
						/>
					);
				})}
			</div> */}

			{/* <div className='p-5 rounded-[10px] bg-primaryViolet mb-[10px] flex flex-row items-end gap-5 mt-[35px] ' style={{ boxShadow: '0px 6px 16.299999237060547px 0px #FFFFFFB2' }}>
				<p className='font-bold text-white text-[20px] leading-[26px] '>Explore more stress specific challenges</p>

				<div className='cursor-pointer' onClick={() => setCurrentMode('suggestion')}>
					<ExtraSuggestionArrowRight />
				</div>
			</div> */}

			<div className='mt-[35px] flex flex-col gap-[10px]'>
				<button className='bg-primaryViolet rounded-full w-full h-[50px] flex flex-row justify-center items-center gap-[10px] cursor-pointer'>
					<Explore />
					<p className='text-[16px] text-white leading-5 font-bold'>Explore quick tipps</p>
				</button>
				<button className='bg-darkenPurple rounded-full w-full h-[50px] flex flex-row justify-center items-center gap-[10px] cursor-pointer'>
					<AiBuddy style={{ color: 'white' }} />
					<p className='text-[16px] text-white leading-5 font-bold'>Chat with AI buddy</p>
				</button>
			</div>
		</div>
	);
}

export default TopicScreen;
